import React from 'react'
import { Image } from 'newComponents'
import './styles.scss'

const CaseStudiesOverview = (props) => {
  const { data } = props
  const {
    primary: {
      overview_content: { html: overviewContent }
    },
    companyName,
    items: stats
  } = data

  return (
    <div className="container case-studies-overview">
      <h2>{companyName} Overview</h2>
      {stats[0].stats_icon.url && (
        <div className="case-studies-overview-stats">
          {stats.map((stat) => {
            const {
              stats_content: { html: statsContent },
              stats_icon: statsIcon
            } = stat
            return (
              <div key={statsContent} className="case-studies-overview-stat-container">
                <div className="case-studies-overview-stat-image">
                  <Image image={statsIcon} />
                </div>
                <div
                  className="case-studies-overview-stat-content"
                  dangerouslySetInnerHTML={{ __html: statsContent }}
                />
              </div>
            )
          })}
        </div>
      )}

      {overviewContent && <div className="case-studies-overview-content" dangerouslySetInnerHTML={{ __html: overviewContent }} />}
    </div>
  )
}

export default CaseStudiesOverview
